import { gql } from 'apollo-boost';

export const GET_S3_UPLOAD_QUERY = gql`
    query s3UploadUrlFor($name: String, $fileType: String, $object: String!) {
        s3UploadUrlFor(name: $name, fileType: $fileType, object: $object) {
            name
            uploadUrl
        }
    }
`;

export const REWARD_CARD_PACKS = gql`
    query rewardCardPacks($published: Boolean) {
        rewardCardPacks(published: $published) {
            id
            name
            published
            coverImageUrl
            designImageUrl
            previewImageUrl
            createdAt
        }
    }

`;

export const UPDATE_REWARD_CARD_PACK_PUBLISH_STATUS = gql`
    mutation updateRewardCardPackPublishedStatus($rewardCardPackId: ID!, $published: Boolean!) {
        updateRewardCardPackPublishedStatus(rewardCardPackId: $rewardCardPackId, published: $published) {
            errors
            rewardCardPack {
                id
            }
        }
    }
`;

export const DELETE_REWARD_CARD_PACK = gql`
    mutation deleteRewardCardPack($rewardCardPackId: ID!) {
        deleteRewardCardPack(rewardCardPackId: $rewardCardPackId) {
            errors
            deleted
        }
    }
`;